export default __webpack_public_path__ + "static/media/game-pagetype-login_game.3c7def69.svg";